"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_responsive_1 = require("react-responsive");
const useMedia = (settings) => {
    const [state, setState] = (0, react_1.useState)(null);
    const isMatch = (0, react_responsive_1.useMediaQuery)(settings, undefined, (matches) => {
        setState(matches);
    });
    return state !== null && state !== void 0 ? state : isMatch;
};
exports.default = useMedia;
